class HTTPService {
  public formData(object: {}): FormData {
    const fData = new FormData();

    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        let value = (object as any)[key];

        // When appending an empty string, Laravel will turn the empty string to a NULL via middleware.
        if (value === null || value === undefined) {
          value = '';
        }

        fData.append(key, value);
      }
    }

    return fData;
  }

  public contentTypeHeader(contentType: string) {
    return { 'Content-Type': contentType };
  }

  public combineHeaders(...headers: object[]) {
    return Object.assign({}, ...headers);
  }

  public deleteRequest(postData: FormData | object | null = null) {
    if (postData instanceof FormData) {
      postData.append('_method', 'DELETE');
    } else if (postData instanceof Object) {
      (postData as any)._method = 'DELETE';
    } else {
      postData = { _method: 'DELETE' };
    }

    return postData;
  }
}

export default new HTTPService();
